export const REVIEW_TEMPLATE_CATEGORIES = {
  womens_tops: [6, 60, 61, 62, 63, 64, 65, 66, 67],
  womens_bottoms: [7, 72, 73, 74, 75, 76, 77, 78, 79],
  womens_sportsbras: [8, 84, 85, 86, 87, 88, 89, 90, 91],
  womens_accessories: [9, 96, 97, 98, 99, 100, 101, 102, 103],
  womens_jackets: [35, 108, 109, 110, 111, 112, 113, 114, 115],
  mens_tops: [126, 183, 185, 187, 189, 193],
  mens_bottoms: [127, 184, 186, 188, 190, 192],
  mens_jackets: [128],
  mens_accessories: [129, 191],
  mens_sweaters: [130],
  shoes: [166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176],
};

export const REVIEW_OPTION_TEMPLATE = {
  placementManual: 0,
  description: '',
  enableComment: false,
  reviewFormControlTypeLabel: '',
  answers: [],
  reviewTemplateFieldTypeId: 0,
  required: false,
  label: '',
  reviewTemplateFieldId: 0,
  reviewFormControlTypeId: 0,
};
